import {
  DUPLICATE_SYMBOLS_PATTERN,
  LATIN_TEXT_PATTERN,
  ONLY_ALLOWED,
} from '../constants/patterns-constants';

export const normalizeInput = (raw: string): string => {
  let str = raw.replace(LATIN_TEXT_PATTERN, "");
  str = str.replace(DUPLICATE_SYMBOLS_PATTERN, "$1");
  str = str.replace(/ ?- ?/g, "-");
  return str.trim();
};

export const capitalizedName = (raw: string): string => {
  return raw
    .trim()
    .split(/\s+/)
    .map((word) =>
      word
      .split("-")
        .map((letter) => (letter ? letter.charAt(0).toUpperCase() + letter.slice(1).toLowerCase()
    : letter)).join("-")).join(" ");
};

export const normalize = (value: string | number | null): string => {
  if (value === null || value === undefined) {
    return "";
  }
  return String(value).trim().toLowerCase();
};

export const filterAllowedChars = (value: string): string => {
  return value
    .replace(/’/g,"'")
    .replace(/[-—]/g,"-")
    .replace(ONLY_ALLOWED, "");
};

export const removeInvalidCharacters = (value: string): string => {
  return value
    .replace(/’/g,"'")
    .replace(/[-—]/g,"-")
    .replace(/[^A-Za-z0-9 '\-’—]/g, "")
    .replace(/\s+/g," ")
    .replace(/-+/g,"-")
    .replace(/'+/g,"'")
    .replace(/^['-]+|['-]+$/g,"")
    .trim();
}

export const isValidLatinName = (value: string): boolean => {
  return /^[A-Za-z0-9](?:[A-Za-z0-9 '-]*[A-Za-z0-9])?$/.test(value);
}
